import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { SectionWrapper } from '../../../brenger-shared-ui';
import IconSmile from '../../../brenger-shared-ui/components/basics/icons/IconSmile';

class VerifySocialAuth extends React.Component {
  public render(): JSX.Element {
    return (
      <SectionWrapper sectionStyle={'white'}>
        <IconSmile spinning={true} /> <Translate id={'authentication.login.redirect_message'} />
      </SectionWrapper>
    );
  }
}

export default VerifySocialAuth;
